module.exports = __webpack_public_path__ + "guides/salesforce-setup-guide.pdf";